import React, { useState, useRef, useEffect} from 'react';
import SelectSearch from 'react-select-search';

import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.css';
import Col from 'react-bootstrap/Col'; 
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row'; 
import Modal from 'react-bootstrap/Modal';

import Clicker from './Clicker';
import Chat from './Chat';
import * as Options from './organizer_options'
import {useChatOn, useGraphOn, useUserMeetings, useWindowSize} from './reusableHooks';
import { useHistory } from 'react-router-dom';

import Header from './Navbar';
import Dashboard from './Dashboard';

function NewMeeting({thisUser, showNewMeeting}) {
  const newMeetingTitle = useRef();
  const newMeetingDate = useRef();
  const newMeetingTime= useRef();
  const participantOptions = useRef([]);
  const organizerOptions = useRef([]);

  const participantTagColors = useRef([]);

  const [validated, setValidated] = useState(false);
  const [organizers, setOrganizers] = useState([]);


  const createNewMeeting = (event) => {
    event.preventDefault();

    const form = event.currentTarget;
    const pOptions = [];
    const oOptions = [];

    const pColors = [];

    participantOptions.current.forEach((option)=> (option.value !== '' && pOptions.push(option.value)))
    organizerOptions.current.forEach((option)=> (option.value !== '' && oOptions.push(option.value)))
    
    participantTagColors.current.forEach((option)=> (option.value !== '' && pColors.push(option.value)))

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    else {
      //console.log(pColors)
      const sessionInfo = {
        name: newMeetingTitle.current.value,
        date: newMeetingDate.current.value,
        time: newMeetingTime.current.value,
        reactions: pOptions,
        colors: pColors ,//need to get colors array from selected choice
        topics: oOptions, 
        organizers: organizers
      }
      Options.newSession(thisUser.uid, sessionInfo);
      showNewMeeting(false);
    }
    setValidated(true);
  }

  const addParticipantRef = (ref) => {
    if(!participantOptions.current.includes(ref) && ref !== null) participantOptions.current.push(ref);
  }
  const addParticipantTagColorRef = (ref) => {
    if(!participantTagColors.current.includes(ref) && ref !== null) participantTagColors.current.push(ref);
    //console.log(participantTagColors)
  }

  const addOrganizerRef = (ref) => {
    if(!organizerOptions.current.includes(ref) && ref !== null) organizerOptions.current.push(ref);
  }

  return (
    <div className="new-meeting">
          <div className="row justify-content-start border-bottom w-100 m-0 pt-4 pb-2">
            <h4 className="font-weight-bold" style={{fontFamily:"Inter"}}>New Meeting</h4>
          </div>
          
          <div className="row px-3">
            <Form noValidate validated={validated} onSubmit={createNewMeeting} className="w-100 text-left">
              <Row className="py-2" >
                <Col md="" className="pt-2">
                  <Form.Label >Title</Form.Label>
                  <Form.Control placeholder="Title" label="Title" ref={newMeetingTitle} id="new-meeting-title" required/>
                </Col>
                <Col md="auto" className="pt-2">
                  <Form.Label className="">Date</Form.Label>
                  <Form.Control type="date" placeholder="Date" label="Date" ref={newMeetingDate} id="new-meeting-date" required/>
                </Col>
                <Col md="auto" className="pt-2">
                  <Form.Label className="">Time</Form.Label>
                  <Form.Control type="time" placeholder="Time" label="Time" ref={newMeetingTime} id="new-meeting-time" required/>
                </Col>
              </Row>

              Participant Tags (at least 2):
              <Row className="py-2 px-2 justify-content-start">
                  <div className="add-tag m-2">
                  <Form.Control defaultValue="Agree" ref={ref => addParticipantRef(ref)} required></Form.Control>
                  {/* INSERT COLOR PICKER */}
                  {/*<Form.Label htmlFor="agree-color-input"></Form.Label>*/}
                  <Form.Control
                    type="color"
                    id="agree-color-input"
                    defaultValue="#59A14F"
                    title="Choose color"
                    className="color-picker"
                    ref={ref => addParticipantTagColorRef(ref)} 
                  />
                  </div>

                  <div className="add-tag m-2">
                  <Form.Control defaultValue="Disagree" ref={ref => addParticipantRef(ref)} required></Form.Control>
                  <Form.Control
                    type="color"
                    id="disagree-color-input"
                    defaultValue="#E15759"
                    title="Choose color"
                    ref={ref => addParticipantTagColorRef(ref)} 
                  />
                  </div>

                  <div className="add-tag m-2">
                  <Form.Control defaultValue="Important" ref={ref => addParticipantRef(ref)}></Form.Control>
                  <Form.Control
                    type="color"
                    id="important-color-input"
                    defaultValue="#4E79A7"
                    title="Choose color"
                    ref={ref => addParticipantTagColorRef(ref)} 
                  />
                  </div>

                  <div className="add-tag m-2">
                  <Form.Control defaultValue="Confused" ref={ref => addParticipantRef(ref)}></Form.Control>
                  <Form.Control
                    type="color"
                    id="confused-color-input"
                    defaultValue="#B07AA1"
                    title="Choose color"
                    ref={ref => addParticipantTagColorRef(ref)} 
                  />
                  </div>

                  <div className="add-tag m-2">
                  <Form.Control defaultValue="Unsure" ref={ref => addParticipantRef(ref)}></Form.Control>
                  <Form.Control
                    type="color"
                    id="unsure-color-input"
                    defaultValue="#F28E2B"
                    title="Choose color"
                    ref={ref => addParticipantTagColorRef(ref)} 
                  />
                  </div>

                  <div className="add-tag m-2">
                  <Form.Control defaultValue="Other" ref={ref => addParticipantRef(ref)} disabled></Form.Control>
                  <Form.Control
                    type="color"
                    id="other-color-input"
                    defaultValue="#BAB0AC"
                    title="Choose color"
                    ref={ref => addParticipantTagColorRef(ref)} 
                  />
                  </div>

              </Row>
              
              Organizer Tags (at least 2):
              <Row className="py-2 px-2 justify-content-start">
                  <Form.Control defaultValue="Main Issue" ref={ref => addOrganizerRef(ref)} className="add-tag m-2" required></Form.Control>
                  <Form.Control defaultValue="Action Item" ref={ref => addOrganizerRef(ref)} className="add-tag m-2" required></Form.Control>
                  <Form.Control defaultValue="Key Point" ref={ref => addOrganizerRef(ref)} className="add-tag m-2"></Form.Control>
                  <Form.Control defaultValue="Topic Shift" ref={ref => addOrganizerRef(ref)} className="add-tag m-2"></Form.Control>
                  <Form.Control defaultValue="Comment" ref={ref => addOrganizerRef(ref)} className="add-tag m-2"></Form.Control>
                  <Form.Control defaultValue="Other" ref={ref => addOrganizerRef(ref)} className="add-tag m-2" disabled></Form.Control>
              </Row>
              
              Organizers: 
              <Row className="py-2">
                <Col className="my-auto" >
                <SelectSearch
                    closeOnSelect={false}
                    printOptions="on-focus"
                    multiple
                    placeholder="Add organizers to your meeting"
                    options={[]}
                    getOptions={() => {
                      return new Promise((resolve, reject) => {
                        Options.getAllOrganizers()
                            .then((organizers) => {
                                resolve(organizers.filter(obj => obj.organizerId !== thisUser.uid).map(({ organizerId, organizerEmail }) => ({ value: organizerId, name: organizerEmail })))
                            })
                            .catch(reject);
                      });
                    }}
                    onChange={(values) => (setOrganizers(values))}
                />
                </Col>
              </Row>

              <Row>
                <Button type="submit" variant="outline-primary" type="submit" className="w-100 m-3">Create New Meeting</Button>
              </Row>
            </Form>
            </div>
    </div>
  );
}



function AddOrganizerModal({show, setShow, thisUser, sessionId}) {

  const mountedRef = useRef(false);

  const handleClose = () => {
    if(mountedRef.current) setShow(false);
  }
  const [organizers, setOrganizers] = useState([]);

  const handleAddOrganizers = () => {
   if(sessionId && mountedRef.current) {
    Options.setSessionOrganizers(organizers, sessionId);
    handleClose();
   }

  }

  useEffect(() => {
    mountedRef.current = true;

    return () => {mountedRef.current = false;}
  }, [])

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Add Organizers</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      Organizers: 
              <Row className="py-2">
                <Col className="my-auto" >
                <SelectSearch
                    closeOnSelect={false}
                    printOptions="on-focus"
                    multiple
                    placeholder="Add organizers to your meeting"
                    options={[]}
                    getOptions={() => {
                      return new Promise((resolve, reject) => {
                        Options.getAllOrganizers()
                            .then((organizers) => {
                                resolve(organizers.filter(obj => obj.organizerId !== thisUser.uid).map(({ organizerId, organizerEmail }) => ({ value: organizerId, name: organizerEmail })))
                            })
                            .catch(reject);
                      });
                    }}
                    onChange={(values) => {if(mountedRef.current) setOrganizers(values)}}
                />
                </Col>
              </Row>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleAddOrganizers}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

//Shows organizers meetings and ability to create a new one
function Meetings({thisUser, setSessionId, myMeetings}) {
 
  const [newMeeting, showNewMeeting] = useState(false);
  const [clickedSessionId, setEditingSession] = useState(null);

  const handleClickSession= (sessionId) => {
    localStorage.setItem("currentSession", sessionId);
    localStorage.removeItem("buttons-disabled");
    setSessionId(sessionId);
  }

  const [show, setShow] = useState(false);

  const editSession = (e, sessionId) => {
    e.stopPropagation();
    setEditingSession(sessionId);
    setShow(true);
  }
  return (
      <div className="container bg-white rounded-lg shadow-sm overflow-scroll">
        
        {(newMeeting === false) && <div className="justify-content-start row border-bottom w-100 m-0 pt-4 pb-2">
          <h4 className="font-weight-bold text-left">Your Meetings</h4>
        </div>}
        {(newMeeting === false)  && 
          <>
          <div className="meetings overflow-scroll">
          {myMeetings?.map((meeting, index) => (
                <div key={meeting.get("sessionId")} className="row meeting text-center py-2" onClick={() => handleClickSession(meeting.get("sessionId"))}>
                  <p key={meeting.get("sessionId")+"-name"} className="col-3 text-left mb-0">{meeting.get("name")}</p>
                  <p key={meeting.get("sessionId")+"-date"} className="col-3 text-center mb-0" style={{whiteSpace: "nowrap", hyphens: "none"}}>{meeting.get("date")}</p>
                  <p key={meeting.get("sessionId")+"-time"} className="col-3 text-right mb-0">
                  {
                    new Date('1970-01-01T' + meeting.get("time") + 'Z')
                    .toLocaleTimeString({}, {timeZone:'UTC',hour12:true,hour:'numeric',minute:'numeric'})
                  }
                  </p>
                  <p className="col-3 mb-0"><Button variant="outline-secondary" type="button" className="m-0" onClick={(e) => editSession(e,meeting.get("sessionId"))}>Add Organizers</Button></p>
                </div>
                ))}
          {(myMeetings === null) && 
            <h5 className="text-secondary blink">Loading...</h5>
          }
        </div>
        <Row>
          <Button type="submit" variant="outline-primary" type="button" className="w-100 m-3" onClick={() => showNewMeeting(true)}>Create New Meeting</Button>
        </Row>
        </>
        }
        {newMeeting && <NewMeeting thisUser={thisUser} showNewMeeting={showNewMeeting}/>}
        <AddOrganizerModal show={show} setShow={setShow} thisUser={thisUser} sessionId={clickedSessionId}/>
      </div>
  )
}

function Admin({thisUser}) {
  const history = useHistory();
  if(thisUser?.isAnonymous) history.push("/");
  const storedSession = localStorage.getItem('currentSession')? localStorage.getItem('currentSession') : null;
  const [sessionId, setSessionId] = useState(storedSession);
  const sessionChatOn = useChatOn(sessionId);
  const sessionGraphOn = useGraphOn(sessionId);
  const myMeetings = useUserMeetings(thisUser?.uid);
  const mountedRef = useRef(false);

  const [view, setView] = useState({
    clicker: true,
    meetings: false,
    dashboard: false
  });

  const windowSize = useWindowSize();
  const [radioValue, setRadioValue] = useState('1');

  const checkButton = (buttonValue) => {
    if(buttonValue==='1' && mountedRef.current){
      setRadioValue('1');
    }
    else if(buttonValue==='2' && mountedRef.current){
      setRadioValue('2');
    }
  }

  const handleClickLink = (link) => {
    if(link === "/admin#dashboard" && mountedRef.current) setView({
      clicker: false,
      meetings: false,
      dashboard: true
    });
    else if(link === "/admin#meetings" && mountedRef.current) setView({
      clicker: false,
      meetings: true,
      dashboard: false
    });
    else if(link === "/admin" &&  mountedRef.current) setView({
      clicker: true,
      meetings: false,
      dashboard: false
    })
  };

  useEffect(() => {
    mountedRef.current = true;

    if(sessionId &&  mountedRef.current){
      setView({
        clicker: true,
        meetings: false,
        dashboard: false
      });

    }
    else if (mountedRef.current) {
      setView({
        clicker: false,
        meetings: true,
        dashboard: false
      });
    }

    return () => { mountedRef.current = false }
  }, [sessionId])

  return (
    <div className="inner-app admin sm">
        <Header type={"admin"} thisUser={thisUser} handleClickLink={handleClickLink} sessionId={sessionId}/>
        {view.meetings && <Meetings thisUser={thisUser} setSessionId={setSessionId} myMeetings={myMeetings}/>}
      
        {sessionId && view.clicker &&
          <div id="parent" className="admin">
            <Clicker sessionId={sessionId} thisUser={thisUser} isAdmin={true} sessionChatOn={sessionChatOn} windowSize={windowSize} radioValue={radioValue} checkButton={checkButton}/>
            <Chat sessionId={sessionId} thisUser={thisUser} isAdmin={true} isSessionChatOn={sessionChatOn} windowSize={windowSize} radioValue={radioValue} checkButton={checkButton}/>
          </div> 
        }
        {sessionId && view.dashboard && <Dashboard sessionId={sessionId} sessionChatOn={sessionChatOn} sessionGraphOn={sessionGraphOn} windowSize={windowSize}/>}
        {sessionId === null && !view.meetings &&
          <h6 className="text-center">You're not in a session.</h6>
        }
    </div>
  );
}

export default Admin;
